import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";

import { EmailConnectionFields } from "./email-connection-fields";
import { useEmailConnectionForm } from "./use-email-connection-form";

import type { EmailConnection } from "@artisancode/api-types";

export function EmailConnectionDialog({
  open,
  onOpenChange,
  editing,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  editing: EmailConnection | null;
}) {
  const { form, isSubmitting, onSubmit } = useEmailConnectionForm(
    open,
    editing,
    () => onOpenChange(false),
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>
            {editing
              ? "Edit Koneksi Email (SMTP)"
              : "Tambah Koneksi Email (SMTP)"}
          </DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form id="email-connection-form" onSubmit={onSubmit} className="py-2">
            <EmailConnectionFields form={form} editing={editing} />
          </form>
        </Form>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Batal
          </Button>
          <Button
            type="submit"
            form="email-connection-form"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Menyimpan..." : editing ? "Simpan" : "Tambah"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
